























































































































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountFactFind } from '@/shared/clients/client-account-fact-find';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component
export default class ClientFactFindDetails extends Vue {
    @userModule.Getter('isAdministrator') public isAdministrator!: boolean;
    @userModule.Getter('isCustomerExperienceExecutiveTeamLeader') public isCustomerExperienceExecutiveTeamLeader!: boolean;
    @userModule.Getter('isDataCreationTeamLeader') public isDataCreationTeamLeader!: boolean;

    @Prop({ required: true }) public client!: ClientAccount;
    private editFactFindDialogVisible: boolean = false;
    private deleteFactFindConfirmationDialogVisible: boolean = false;
    private saving: boolean = false;

    private get factFind(): ClientAccountFactFind {
        return this.client!.factFind!;
    }
    private get canDelete(): boolean {
        return this.isAdministrator || this.isCustomerExperienceExecutiveTeamLeader || this.isDataCreationTeamLeader;
    }
    private showEditDialog(factfind: ClientAccountFactFind) {
        this.editFactFindDialogVisible = true;
    }
    private showDeleteConfirmation(interaction: ClientAccountFactFind): void {
        this.deleteFactFindConfirmationDialogVisible = true;
    }
    private onFactFindUpdated(factFind: ClientAccountFactFind): void {
        this.onCancel();
        this.$emit('fact-find-updated', factFind);
    }
    private async onDelete(): Promise<void> {
        this.$emit('fact-find-removed', { ...this.client.factFind! });
        this.onCancel();
    }
    private onCancel(): void {
        this.editFactFindDialogVisible = false;
        this.deleteFactFindConfirmationDialogVisible = false;
    }
}
